"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFetchIndicator = TableFetchIndicator;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var tableContext_1 = require("../../../contexts/tableContext");
function TableFetchIndicator(_a) {
    var className = _a.className;
    var isBusy = (0, tableContext_1.useTableContext)().isBusy;
    // overlays the frame's top edge, so it costs no layout space and the rounded corners clip it
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, react_1.cn)("pointer-events-none absolute inset-x-0 top-0 z-20 h-1", className), children: isBusy && ((0, jsx_runtime_1.jsx)(react_1.ProgressBar, { "aria-label": "Loading results", className: "gap-0", color: "accent", isIndeterminate: true, size: "sm", children: (0, jsx_runtime_1.jsx)(react_1.ProgressBar.Track, { className: "bg-transparent", children: (0, jsx_runtime_1.jsx)(react_1.ProgressBar.Fill, {}) }) })) }));
}
